import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import Sidebar from '../components/Sidebar';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}

export default function Profile() {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [userData, setUserData] = useState(null);
  const [form, setForm] = useState({ name:'', phone:'', email:'' });
  const [saved, setSaved] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem('winal_theme') || 'dark');

useEffect(() => {
  document.body.classList.toggle('light', theme === 'light');
  localStorage.setItem('winal_theme', theme);
}, [theme]);

  useEffect(() => { loadUser(); }, []);

  const loadUser = async () => {
    try {
      const res = await api.get(`/users/email/${encodeURIComponent(user.email)}`);
      setUserData(res.data);
      setForm({ name: res.data.name || '', phone: res.data.phone || '', email: res.data.email || '' });
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put(`/users/${userData.id}`, { name: form.name, phone: form.phone });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (e) { alert('Error guardando perfil'); }
    finally { setSaving(false); }
  };

  const inputStyle = {
    width:'100%', background:'var(--sd)', border:'1px solid var(--sborder)',
    borderRadius:8, padding:'10px 14px', color:'var(--st)',
    fontSize:13, outline:'none', boxSizing:'border-box'
  };

  const roleLabels = { seller:'Vendedor', manager:'Manager', director:'Director', superadmin:'Super Admin' };
  const roleColors = { seller:'#3B82F6', manager:'#00C853', director:'#F59E0B', superadmin:'#F59E0B' };
  const ml = isMobile ? 0 : 220;
  const pt = isMobile ? 56 : 0;

  if (loading) return (
    <div style={{ display:'flex' }}>
      <Sidebar active="profile" />
      <div style={{ marginLeft: ml, paddingTop: pt, flex:1, display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh' }}>
        <div style={{ color:'var(--sg)', fontSize:14 }}>Cargando...</div>
      </div>
    </div>
  );

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'var(--sd)' }}>
      <Sidebar active="profile" />

      <div style={{ marginLeft: ml, paddingTop: pt, flex:1, padding: isMobile ? '12px' : '24px', maxWidth:600, boxSizing:'border-box' }}>

        <div style={{ marginBottom:28 }}>
          <div style={{ fontSize:17, fontWeight:500 }}>Mi perfil</div>
          <div style={{ fontSize:12, color:'var(--sm)', marginTop:3 }}>Editá tu información personal</div>
        </div>

        {/* Avatar */}
        <div style={{ display:'flex', alignItems: isMobile ? 'flex-start' : 'center', gap:20, marginBottom:24, padding:'20px 24px', background:'var(--sgr)', borderRadius:12, border:'1px solid var(--sborder)', flexDirection: isMobile ? 'column' : 'row' }}>
          {user?.photoURL ? (
            <img src={user.photoURL} alt="avatar" style={{ width:72, height:72, borderRadius:'50%', objectFit:'cover', border:'3px solid var(--sg)', flexShrink:0 }}/>
          ) : (
            <div style={{ width:72, height:72, borderRadius:'50%', background:'var(--sg)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:24, fontWeight:600, color:'var(--sb)', flexShrink:0 }}>
              {form.name?.slice(0,2).toUpperCase() || 'US'}
            </div>
          )}
          <div>
            <div style={{ fontSize:18, fontWeight:600, color:'var(--st)', marginBottom:4 }}>{form.name}</div>
            <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
              <span style={{ fontSize:11, fontWeight:500, padding:'3px 10px', borderRadius:20, background:`${roleColors[userData?.role]}20`, color:roleColors[userData?.role] || 'var(--sm)' }}>
                {roleLabels[userData?.role] || userData?.role}
              </span>
              <span style={{ fontSize:12, color:'var(--sm)' }}>{user?.email}</span>
            </div>
            <div style={{ fontSize:11, color:'var(--sm)', marginTop:6 }}>La foto se toma de tu cuenta de Google</div>
          </div>
        </div>

        {/* Formulario */}
        <div style={{ background:'var(--sgr)', borderRadius:12, border:'1px solid var(--sborder)', padding:'24px', marginBottom:16 }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:20, color:'var(--st)' }}>Información personal</div>
          <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
            <div>
              <div style={{ fontSize:12, color:'var(--sm)', marginBottom:6 }}>Nombre completo</div>
              <input value={form.name} onChange={e => setForm({...form, name:e.target.value})} placeholder="Tu nombre" style={inputStyle}/>
            </div>
            <div>
              <div style={{ fontSize:12, color:'var(--sm)', marginBottom:6 }}>WhatsApp</div>
              <input value={form.phone} onChange={e => setForm({...form, phone:e.target.value})} placeholder="+5491112345678" style={inputStyle}/>
              <div style={{ fontSize:11, color:'var(--sm)', marginTop:4 }}>Este número recibe el check-in diario y los recordatorios</div>
            </div>
            <div>
              <div style={{ fontSize:12, color:'var(--sm)', marginBottom:6 }}>Email</div>
              <input value={form.email} disabled style={{ ...inputStyle, opacity:0.5, cursor:'not-allowed' }}/>
              <div style={{ fontSize:11, color:'var(--sm)', marginTop:4 }}>El email está vinculado a tu cuenta de Google y no se puede cambiar</div>
            </div>
          </div>
          <div style={{ marginTop:24, display:'flex', alignItems:'center', gap:12 }}>
            <button onClick={handleSave} disabled={saving} style={{ background:'var(--sg)', color:'var(--sb)', border:'none', borderRadius:8, padding:'10px 24px', fontSize:13, fontWeight:500, cursor:'pointer', opacity:saving?0.7:1 }}>
              {saving ? 'Guardando...' : 'Guardar cambios'}
            </button>
            {saved && <div style={{ fontSize:13, color:'var(--sg)' }}>✓ Cambios guardados</div>}
          </div>

          <div style={{ marginTop:24, paddingTop:20, borderTop:'1px solid var(--sborder)' }}>
            <div style={{ fontSize:14, fontWeight:500, marginBottom:16, color:'var(--st)' }}>Apariencia</div>
            <div style={{ display:'flex', gap:10 }}>
              {['dark', 'light'].map(t => (
                <button key={t} onClick={() => setTheme(t)} style={{ flex:1, padding:'12px', borderRadius:8, cursor:'pointer', fontSize:13, border: theme === t ? '2px solid var(--sg)' : '1px solid var(--sborder)', background: theme === t ? 'rgba(0,200,83,0.08)' : 'var(--sd)', color: theme === t ? 'var(--sg)' : 'var(--sm)', fontWeight: theme === t ? 500 : 400 }}>
                  {t === 'dark' ? '🌙 Modo oscuro' : '☀️ Modo claro'}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Info de cuenta */}
        <div style={{ background:'var(--sgr)', borderRadius:12, border:'1px solid var(--sborder)', padding:'24px' }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:16, color:'var(--st)' }}>Información de cuenta</div>
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {[
              { label:'Rol', value:roleLabels[userData?.role] || userData?.role },
              { label:'Miembro desde', value: userData?.createdAt?._seconds ? new Date(userData.createdAt._seconds * 1000).toLocaleDateString('es', { year:'numeric', month:'long', day:'numeric' }) : '—' },
            ].map((item, i) => (
              <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 0', borderBottom: i < 3 ? '1px solid rgba(255,255,255,0.05)' : 'none', flexWrap:'wrap', gap:8 }}>
                <div style={{ fontSize:13, color:'var(--sm)' }}>{item.label}</div>
                <div style={{ fontSize:13, fontWeight:500, color:'var(--st)' }}>{item.value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}